<template>
    <div class="con_content">
        <template v-if="!list2Bool">
            <div class="container">
                <div class="container_top h_48">用户列表</div>
            
                <!-- table组件 -->
                <div class="my_table">
                    <Header class="my_title txt_l">
                        <span class='my_titleL'>
                            <Icon class="fw_900 " type="ios-list" size='30'/>     
                            筛选查询
                        </span>
                    
                    </Header>
                    <div class="my_search">
                        
                            <Row class="search_row">  
                                <div  class="search_name">
                                用户账号:  
                                </div>
                                
                                <Col span="4" class="listIpt">
                                <Input  ref='isFocuseA'    :maxlength='20'  class='ipt   top13'  placeholder="用户ID/账号" @keyup.enter.native="mobileFun" v-model="mobile">
                                        <Button size="small"  @click='mobileFun'  slot="append" icon="md-search"></Button>
                                </Input>
                                </Col>
                        
                                <div  class="search_name">
                                    用户昵称:
                                </div>
                                
                                <Col span="4" class="listIpt">
                                    <Input  ref='isFocuseB'    :maxlength='20'  class='ipt  top13  '  placeholder="用户昵称" @keyup.enter.native="nameFun" v-model="name">
                                        <Button size="small" @click='nameFun'  slot="append" icon="md-search"></Button>
                                    </Input>
                                </Col>
                                <div  class="search_name">
                                    注册时间:
                                </div>
                                
                                <Col span="4">

                                    <DatePicker ref='isFocuseC'   @on-change='timeFun' v-model="time"  type="date" placeholder="请选择时间"   clearable ></DatePicker>
                                </Col>
                            </Row>
                            
                    </div>
                
                </div>
                <!-- table组件 -->
                <div class="my_table  ">
                    <Header class="my_title txt_l">
                        <span class="my_titleL">
                        <Icon class="fw_900 " type="ios-list" size='30'/>     
                            数据列表 
                        </span>
                        
                        <div class="ct_rgt">
                            
                            <div class="sta_btn " type="primary"   @click="exportData">导出数据</div>
                            
                        </div>
                    </Header>
                    <Table border :columns="columns1" :data="data1" no-data-text='N/A' ref='table'>
                    
                        <!-- 头像 -->
                        <template slot-scope="{ row }" slot="image">
                            <div class="demo-avatar">
                                <Avatar v-if="row.image == null" icon="ios-person" size="large" />
                                <Avatar v-else  :src="row.image" size="large"/> 
                            </div>                        
                        </template>
                    
                        <!-- 按钮 -->
                        <template slot-scope="{ row, index }" slot="btn">
                            <Poptip trigger="hover" :title="row.surname" content="查看">
                                <Button class="padlr5" size="small"  @click="route = '/layout/user/list/query';show(index);"  type="info"    icon="md-search"  ></Button>
                            </Poptip>  
                            <Poptip trigger="hover" :title="row.surname" content="编辑">
                                <Button class="padlr5" size="small"  @click="route = '/layout/user/list/editor';show2(index); "  type="success"      icon="md-open"></Button>
                            </Poptip>
                        
                        </template>
                        <!-- 三方登录 -->
                        <template slot-scope="{ row }" slot="login">
                            <div class="demo-avatar">
                                <!-- weixin -->
                                <Avatar class="login" v-if="row.weixin == null"  src="/images/ic_weixin_1.png"  />
                                <Avatar class="login" v-if="row.weixin != null"  src="/images/ic_weixin_2.png" /> 
                                <!-- qq -->
                                <Avatar class="login" v-if="row.qq == null" src="/images/ic_qq_1.png"  />
                                <Avatar class="login" v-if="row.qq != null" src="/images/ic_qq_2.png" /> 
                                <!-- ios -->
                                <Avatar class="login" v-if="row.ios == null" src="/images/ic_ios_1.png"  />
                                <Avatar class="login" v-if="row.ios != null" src="/images/ic_ios_2.png" /> 
                                <!-- sina -->
                                <Avatar class="login"  src="/images/ic_sina_1.png"  />
                                <!-- mail 308007  -->
                                <Avatar class="login" v-if="!row.email" src="/images/ic_mail_1.png"  />
                                <Avatar class="login" v-if="row.email " src="/images/ic_mail_2.png" /> 
                                {{row.mail}}
                            </div>                        
                        </template>

                    </Table>
                    <Footer>
                        <Page  :current.sync="page" :total="toatalPage" :page-size='pageSize'    @on-change='changepage'  show-total  show-elevator />
                    </Footer>
                    
                
                </div>

            </div>
            <!-- 操作 => 编辑 -->
            <Modal
                v-model="bj"
                title="编辑"
            
                class-name="vertical-center-modal"
        
                >
                <div slot="footer">
                    <Button type='text' size='large' @click='bjFail'>取消</Button>
                    <Button type='primary' size='large' @click='bjSucc'>确定</Button>
                </div>
                <ul class="list_ul">
                    <!-- 手机号码 -->
                    <li> 
                        <div class='list_title'>账号 :</div>
                        <div class="list_con">
                            <Input   v-model="mobile2"   type='text' class="ipt"    disabled />
                        </div>
                    
                    </li>
                    <!-- 会员等级 -->
                    <li>
                        <div class='list_title'>会员等级 :</div> 
                        <div class="list_con">
                            <Select  class='selectL'      v-model="vipTypeGuid"  @on-change='vipFun'    >
                                <Option v-for="item in  vipNames"     :value="item.value" :key="item.value"  >{{ item.label }}</Option>
                            </Select>
                        </div>                              
                    
                    </li>
                    <!-- 会员截止 -->
                    <li v-show='vipTypeGuid != "null" '> 
                        <div class='list_title'>会员截止 :</div>      
                        <div class="list_con">
                            <DatePicker  style='width:100%;'    @on-change='timeFun' v-model="time2"  type="datetime" placeholder="请选择时间"   clearable ></DatePicker>
                        </div>                        
                        
                    </li>
                    <li  v-if='vipTypeGuid == "0a560f96a6e811e99e549c5c8e7b8156" '>
                        <div class='list_title'>持有股权 :</div>
                        <div class="list_con">
                            <Input  disabled   :maxlength="20"  type='text' class="ipt"  placeholder="无股权" v-model="shares"   />
                        </div>
                    </li>
                    <li>
                        <div class='list_title'>持有孝心值 :</div>
                        <div class="list_con">
                            <Input  disabled   :maxlength="20"  type='text' class="ipt"  placeholder="无孝心值" v-model="integral"  />
                        </div>
                    </li>
                    <li>
                        <div class='list_title'>持有佣金 :</div>
                        <div class="list_con">
                            <Input  disabled   :maxlength="20"  type='text' class="ipt"  placeholder="无佣金" v-model="commission"   />
                        </div>
                    </li>
                    <li>
                        <div class='list_title'>姓名 :</div>
                        <div class="list_con">
                            <!-- 姓 -->
                            <Input  class="nameW"   :maxlength="20"  type='text'   placeholder="姓" v-model="surname2" clearable  />
                            <!-- 名 -->
                            <Input class="nameW"   :maxlength="20"  type='text'   placeholder="名" v-model="name2" clearable  />
                        </div>
                        
                    </li>
                    <!-- 性别 -->
                    <li>
                        <div class='list_title'>性别 :</div>  
                        <div class="list_con">
                            <RadioGroup v-model="sex"  class='sex_css'>
                                <Radio label="1">
                                    <Icon type="ios-man" />
                                    
                                    <span>男</span>
                                </Radio>
                                <Radio label="2">
                                    <Icon type="ios-woman" />
                                    <span>女</span>
                                </Radio>
                                
                            </RadioGroup>

                            <!-- 隐藏的input，只为撑起高度 -->
                            <Input  style="width:10px;visibility:hidden;"    type='password' class="ipt"  placeholder="请输入新密码"  disabled   />
                        </div>                             
                        
                    </li>
                    <!-- UID码 -->
                    <li>  
                        <div class='list_title'>ID号 :</div>   
                        <div class="list_con">
                            <Input  disabled   :maxlength="20"  type='text' class="ipt"  placeholder="请输入ID号" v-model="UID" clearable  />
                        </div>                   
                        
                    </li>
                    <!-- 新密码 -->
                    <li> 
                        <div class='list_title'>新密码 :</div>   
                        <div class="list_con">
                            <Input    :maxlength="20"  type='password' class="ipt"  placeholder="请输入新密码" v-model="newPassword" clearable  />
                        </div>        
                        
                    </li>
                        <!-- 确认密码 -->
                    <li>
                        <div class='list_title'>确认密码 :</div>
                        <div class="list_con">
                            <Input    :maxlength="20"  type='password' class="ipt"  placeholder="请输入确认密码" v-model="affirmPassword" clearable  />
                        </div>
                        
                    </li>
                    <li>
                        <div class='list_title'> <span class="cRed">*</span> 备注信息 :</div>
                        <div class="list_con">
                            <Input   type="textarea" :rows="5" v-model="my_text"  placeholder="请输入备注" />
                        </div>
                        
                    </li>
                
                    <!-- <li>
                        <Button  class="user_btn btn mr20" @click='returnFun' style='background:#ff9900!important;'>复原</Button>
                        <Button  class="user_btn btn" @click='changeFun'>提交</Button>
                    </li> -->
                </ul>
            </Modal>
        </template>
        
        <list2 v-if="list2Bool" ></list2>
    </div>
</template>

<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    import CryptoJS from 'crypto-js'
    import { parse } from 'path';
    import list2 from './list2.vue'

    export default {
        name:'list',
        data () {
            return {
                route:null,
                token:'',
                list2Bool: false,
                // 搜索
                mobile:'',
                name:'',
                time_star:'',
                time_end:'',

                time:'',

                // table
                total:null,
                columns1:[],
                data1:[],
                toatalPage:0,
                page:1,
                pageCurrent:1,
                pageSize:20,

               
                bj:false,      //编辑弹窗


                checkGuid2:'',
                checkGuid3:'',
                mobile2:'',
                vipTypeGuid:null,
                vipNames:null,
                vipName:null,
                nowTime:null,   //当前时间
                time2:null,
                time3:null,
                name2:null,
                surname2:null,
                sex: null,
                UID:null,
                newPassword:null,
                affirmPassword:null,
                shares:0,    //持有股权
                integral: 0,    //持有孝心值
                commission: 0,  //持有佣金
               
                my_text:""
            }
        },
       
        watch:{
            '$store.state.checkGuid2':function(){
                this.$store.state.checkGuid2?this.list2Bool = true:this.list2Bool = false;
               
            }
        },
        computed: {
          
            
        },
        components:{ list2:list2},
        methods: {
           load(btn){
                var that = this;
                 // vuex
                that.token = that.$store.state.token;

                var url;
                var mUrl = 'account/service/admin/users/search?guid='+that.checkGuid;
                //  0是关闭和初始,1是搜索框，2是分页
                if(btn == 0){
                    url = mUrl+'&page=1';  //初始化
                }else if(btn == 1){
                    if(that.mobile){
                        url = mUrl+'&page=1&mobile='+that.mobile.replace(/\s*/g,"");  //提交type
                    }else if(that.name){
                        url = mUrl+'&page=1&name='+that.name.replace(/\s*/g,"");   //提交time
                    }else if(that.time){
                        url = mUrl+'&page=1&time='+that.time.replace(/\s*/g,"");
                    }else{
                        url = mUrl + '&page=1';
                    }
                }else if(btn == 2){
                    
                    if(that.mobile){
                        url = mUrl+'&page='+that.page+'&mobile='+that.mobile.replace(/\s*/g,"");
                    }else if(that.name){
                        url = mUrl+'&page='+that.page+'&name='+that.name.replace(/\s*/g,"");
                    }else if(that.time){
                        url = mUrl+'&page='+that.page+'&time='+that.time.replace(/\s*/g,"");
                    }else{
                        url = mUrl + '&page='+that.page;
                    }
                }

               
                that.$ajax({
                
                    method:'get',
                    url: url,
                    data: {},
                   
                }).then(res => {
                        
                    var total = res.data.data;
                    var list = res.data.data.list;
                    // console.log('loginLog',total,list)
                    that.total = total;
                    var len = list.length;
                    
                        
                    that.columns1 = [
                        {title:'用户ID',key:'number',align:'center',width:100},
                        {title:'用户账号',key:'mobile',align:'center',minWidth:80,maxWidth:140,
                            render: (h, params) => {
                                if(params.row.mobile==null){
                                    return h('div', {},'N/A')
                                }else{
                                    return h('div', {},params.row.mobile)
                                }             
                            }
  
                        },
                        {title:'用户昵称',key:'surname',align:'center',minWidth:80,maxWidth:140},
                        {title:'头像',slot:'image',align:'center',width:100},
                        {title:'会员等级',key:'vipName',align:'center',minWidth:80,ellipsis:true},
                        {title:'第三方登录',slot:'login',align:'center',width:230},
                        {title:'消费金额',key:'expenditureAmount',align:'center',minWidth:80},
                        {title:'邀请好友',key:'invitationCount',align:'center',width:100},
                        
                        {title:'孝心值',key:'integral',align:'center',width:100},
                        {title:'创建时间',key:'createTime',align:'center',minWidth:120,maxWidth:190},
                        {title:'最后登录时间',key:'lastLoginTime',align:'center',minWidth:120,maxWidth:190},
                        // {title:'账户启用状态',key:'???',align:'center',width:110},
                        {title:'操作',slot:'btn',align:'center',width:120,fixed: 'right'}
                        
                    ];
                    
                   for(var i=0;i<len;i++){
                         //用户昵称
                        list[i].surname = list[i].surname + list[i].name;
                        //消费金额   改json
                        list[i].expenditureAmount = '￥'+ (list[i].expenditureAmount/100).toFixed(2);
                    }

                    that.data1 = list;

                    that.toatalPage = total.total;
                    that.pageSize = total.pageSize;
                    
                    
                    // console.log('list',list[0].expenditureAmount)
                }).catch(err=>{
                    console.log(err)
                })

              
           },
           changepage(index){
               var that = this;
              
               that.load(2);
           },

            // search选择
           mobileFun(){
                var that = this;

                that.page = 1;
                that.time = '';
                that.name = '';
                that.load(1);
            },
            nameFun(){
                var that = this;


                that.page =1;
                that.mobile = '';
                that.time = '';
                that.load(1);
            },
            //    选择日期
           timeFun(data){
               var that = this;

               // 时间不能小于当前时间
               // that.timeBool(data);
               that.page = 1;
               that.mobile = '';
               that.name = '';
               that.time = data;
               that.load(1);
           },

            // 清空
            clearFun(){
               var that = this;
               that.page = 1;
               that.mobile = '';
               that.name = '';
               that.time = '';
               that.load(0);
            },
        
           //导出数据
           //    导出
            exportData(){
                var that = this;
                that.$refs.table.exportCsv({
                    filename: '用户列表',
                    original: false
                });
               
            },



            // 点击表格查看跳转
            show(data){
                var that = this;
                var checkGuid2 = that.data1[data].guid;
                that.$store.commit('change_checkGuid2',checkGuid2);
                
                that.$canBtn(that.route).then( function(res){
                    that.list2Bool = true
                    that.goTop();
                })

            },
            goTop(){            //返回顶部
                document.body.scrollTop = 0
                document.documentElement.scrollTop = 0

            },
            // 点击表格查看编辑弹窗
            show2(data){
                var that = this;
                var checkGuid3 = that.data1[data].guid;

                 that.$canBtn(that.route).then( function(res){
                    // that.$store.commit('change_checkGuid2',checkGuid2);
                    // that.checkGuid2 = that.$store.state.checkGuid2;
                    that.checkGuid3 = checkGuid3;
                    that.bjLoad();
                    that.bj = true;
                    that.time3 = null;
                })

            },

            // 编辑弹窗
            bjLoad(){
                var that = this;
                // 现在时间，时间戳格式
                var  now = new Date();
                that.nowTime = now.getTime();
                
                
                
                that.$ajax({
                
                    method:'get',
                    url: 'admin/service/admin/user?guid='+that.checkGuid3+'&route=' + that.route,
                    data: {},
                    
                }).then(res => {
                    var list;
                    list = res.data.data;
                    that.mobile2 = list.mobile;
                    // 会员等级
                    if(list.vipTypeGuid){
                         that.vipTypeGuid = list.vipTypeGuid;
                    }else{
                         that.vipTypeGuid = 'null';
                    }
                   

                    that.vipName = list.vipName;
                    that.name2 = list.name;
                    that.surname2 = list.surname;

                    list.sex == 0? that.sex='2': that.sex=list.sex.toString();
                    
                    that.UID = list.number;
                    that.time2  = list.vipExpire;

                    that.shares = list.shares,    //持有股权
                    that.integral = list.integral,    //持有孝心值
                    that.commission = list.commission  //持有佣金
                     
                }).catch(err=>{
                    console.log(err)
                })


              
               
                that.$ajax({
                
                    method:'get',
                    url: 'account/service/rechage/get/vip_package',
                    data: {},
                   
                }).then(res => {
                   
                    var list = res.data.data;
                    var vipNames=[];
                    var obj;
                    vipNames.push({'label':'非会员','value':'null'});
                    for( var i in list){
                        obj = {'label':list[i].title,'value': list[i].typeGuid }
                        vipNames.push(obj);
                    }
                    

                    that.vipNames = vipNames;

                    // 会员等级对应数据
                   
                }).catch(err=>{
                    console.log(err)
                })

              
           },


            vipFun(){
            //    console.log(data,that.$moment(data).add(3,'months').format("YYYY-MM-DD HH:mm:ss"))
               var that = this;
            //    现在时间
               var  now = new Date();
                that.nowTime = now.getTime();


               if(  that.vipTypeGuid == 'null'){                                    //非会员
                    that.time2 = '2000-01-01 00:00:00';
                    that.time3 = '2000-01-01 00:00:00';
               }else if(  that.vipTypeGuid == '0a560f96a6e811e99e549c5c8e7b8156'){   //豪华会员
                    that.time2 = that.$moment(that.nowTime).add(500,'Y').format("YYYY-MM-DD HH:mm:ss")
                    that.time3 = that.$moment(that.nowTime).add(500,'Y').format("YYYY-MM-DD HH:mm:ss")
               }else if(  that.vipTypeGuid == 'fda434b2b4f611e98ed800163f00f444'){   //包月会员
                    that.time2 = that.$moment(that.nowTime).add(1,'months').format("YYYY-MM-DD HH:mm:ss")
                    that.time3 = that.$moment(that.nowTime).add(1,'months').format("YYYY-MM-DD HH:mm:ss")
               }else if(  that.vipTypeGuid == 'cc4a023dc3c511e9a79600163f00f444'){   //包年会员
                    that.time2 = that.$moment(that.nowTime).add(1,'Y').format("YYYY-MM-DD HH:mm:ss")
                    that.time3 = that.$moment(that.nowTime).add(1,'Y').format("YYYY-MM-DD HH:mm:ss")
               }
           
           },
           switchFun(status){
            //    console.log(status)
           },
           timeBool(date){
                var that = this;
                var nowTime = that.nowTime;
                var newTime = new Date(date).getTime();
                
                if(newTime<nowTime){
                    that.$alert.info('时间不能小于当前时间');
                    
                    //    刷新时间
                    that.$ajax({
                
                        method:'get',
                        url: 'account/service/admin/user?guid='+that.checkGuid2,
                        data: {},
                       
                    }).then(res => {
                        var list;
                        list = res.data.data;
                        that.time2 = list.vipExpire;
                        
                    }).catch(err=>{
                        console.log(err)
                    })
                }
           },
           

            // 提交
           changeFun(){
               var that = this;
                var apwd = that.affirmPassword;
                var npwd = that.newPassword;


                // 密码信息
                var encrypt_password 
                if( apwd && npwd){
                    apwd = that.affirmPassword.replace(/\s*/g,"");
                    npwd = that.newPassword.replace(/\s*/g,"");
                    if( apwd != npwd){
                        that.$alert.info('新密码与确认码不一致');
                        
                        return;
                    }else if(apwd.length < 6){
                        that.$alert.info('密码不能小于6位');
                        
                        return;
                    }
                    // 加密密码,提交apwd为确认码
                    encrypt_password = CryptoJS.HmacSHA1(apwd, "OT2NDh41").toString().toUpperCase();
                }else{
                     encrypt_password = null;
                }

               
                // 除密码外的信息
                var  vipTypeGuid,time,name,surname,sex,number;
            
                if(that.vipTypeGuid == 'null'){
                    vipTypeGuid = "";
                    time = "2000-01-01 00:00:00";
                }else{
                    vipTypeGuid = that.vipTypeGuid;
                    time = that.time2;
                    
                }
                time = that.$moment(that.nowTime).format("YYYY-MM-DD HH:mm:ss")
               

                that.name2? (name = that.name2):(name = null);
                that.surname2? (surname = that.surname2):(surname=null);
                that.sex? (sex = that.sex):(sex=null);

                // UID
                that.UID? (number = that.UID):(number=null);
                number=parseInt(number);
                    
                
                // if(!that.my_text){
                   
                //     that.$alert.info('备注不能为空');
                
               
                // }else{

                     // 提交信息 (除备注信息以外信息)
                    let list_data = {
                            "guid": that.checkGuid2,
                            "vipTypeGuid": vipTypeGuid,
                            "vipExpire": that.time3,
                            "name": name,
                            "surname": surname,
                            "sex": sex,
                            "number": number,
                            "password": encrypt_password,
                    }
                    that.$ajaxNull.post(list_data)
                    that.$ajax({
                
                        method:'put',
                        url: 'account/service/user',
                        data: list_data,
                       
                    }).then(res => {
                        that.$alert.info(res);
                        

                        that.bj = false;
                        that.load(2);
                        that.affirmPassword = '';
                        that.newPassword = '';
                        
                    }).catch(err=>{
                        console.log(err)
                    });

                    // 提交备注信息
                    // that.$ajax({
                
                    //     method:'post',
                    //     url: 'account/service/admin/user/update/gold_coin',
                    //     data: {
                    //         userGuid: that.checkGuid2,
                    //         content:  that.my_text
                    //     },
                   
                    // }).then(res => {
                           
                      
                    // }).catch(err=>{
                    //     console.log(err)
                    // }) 




                // }

               
            
            
               
                
           },
            //    复原
            returnFun(){
                var that = this;
                that.newPassword = '';
                that.affirmPassword = '';
                that.my_text="";
            },

            // 弹窗确认按钮
            bjSucc(){
                this.changeFun();
                
            },
            // 关闭弹窗按钮
            bjFail(){
                this.returnFun();
                this.bj = false;
            },


            
        },
        mounted: function(){
           
           var that = this;
           that.checkGuid = that.$store.state.checkGuid;
           
           that.load(0);
           
            
        }
    }
</script>
<style>
    .listIpt   .ivu-input-large{
        /* padding: 8px 6px; */
    }

    .table table{
      width: 100% !important;
    }
    
    /* 弹窗 */
    .list_ul{
        width:100%;
        height: auto;
    }
    .list_ul li{
        width: 100%;
        height: auto;
        overflow: hidden;
        padding: 5px 0;
    }
    .list_ul .list_title{
        float: left;
        width: 26%;
        text-align: right;
        padding-right: 10px;
        line-height: 32px;
        font-size: 14px;
    }
    .list_ul .list_con{
        float: left;
        width: 60%;
    }
   

   .nameW{
       
       width: 40%;
       
   }
    .nameW:first-child{
       margin-right: 20%; 
    }

    .login{
        margin-left: 3px;
        margin-right: 3px;
    }

</style>



